import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem("shonics_token");
    if (!t) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("shonics_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password, twoFACode) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.requires_2fa) {
      if (!twoFACode) return { requires_2fa: true, challenge: data.challenge };
      const verify = await api.post("/auth/login/verify-2fa", { challenge: data.challenge, code: twoFACode });
      localStorage.setItem("shonics_token", verify.data.token);
      setUser(verify.data.user);
      return verify.data.user;
    }
    localStorage.setItem("shonics_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const verify2FA = async (challenge, code) => {
    const { data } = await api.post("/auth/login/verify-2fa", { challenge, code });
    localStorage.setItem("shonics_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("shonics_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("shonics_token");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, verify2FA }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
